export default {
    usageManagement: {
        page: {
            title: 'システム管理センター',
            description: 'ユーザー使用量、モデル設定、ツール設定、Langfuse Promptを管理',
        },
        tabs: {
            overview: 'セッション監視',
            usage: 'ユーザー使用量',
            model: 'モデル設定',
            tool: 'ツール設定',
            prompt: 'Prompt管理',
            feedback: 'フィードバック管理',
            payment: '決済統計',
            tokenUsage: 'Token使用量',
            report: '統計レポート',
            userActivityReport: 'ユーザーアクティビティレポート',
            assetStats: 'アセット統計',
            documentStats: '文書統計',
            skill: 'Skill管理',
            role: 'ロール管理',
        },
        overview: {
            metrics: {
                totalSessions: '総セッション数',
                avgDuration: '平均セッション時間',
                avgRounds: '平均対話ラウンド数',
                successRate: 'タスク成功率',
                activeUsers: 'アクティブユーザー数',
            },
            date: { today: '今日', yesterday: '昨日', last3days: '直近3日', last7days: '直近7日' },
            refresh: '更新',
            table: {
                sessionId: 'セッションID', user: 'ユーザー', email: 'メール', ip: '所在地',
                rounds: '対話ラウンド数', duration: '継続時間', successFailure: '成功/失敗',
                startTime: '開始時刻', copy: 'コピー', intranet: 'イントラネット',
            },
            drawer: {
                title: 'セッション詳細', sessionId: 'セッションID', user: 'ユーザー', email: 'メール',
                taskId: 'タスクID', status: 'ステータス', ip: 'IP', duration: '所要時間', startTime: '開始時刻',
            },
            copied: 'コピーしました',
            searchEmail: 'メールアドレスを検索',
        },
        usage: {
            config: {
                title: 'グローバル設定', baseTab: '基本設定', visitorLimit: 'ゲスト1日制限', accountLimit: '無料ユーザー制限',
                userTaskConcurrencyLimit: '有料ユーザー単一並行制限',
                globalTaskConcurrencyLimit: '有料ユーザーグローバル並行制限',
                freeUserTaskConcurrencyLimit: '無料ユーザー単一並行制限',
                freeGlobalTaskConcurrencyLimit: '無料ユーザーグローバル並行制限',
                aiCallsPerMinuteLimit: 'モデル呼び出し毎分制限',
                aiCallsCurrentCount: '現在のAI呼び出し数（今分）',
                aiCallsCurrentCountUnit: '回',
                save: '設定を保存', hint: '変更はすべての新規ユーザーに適用されます',
            },
            metrics: {
                totalUsage: '本日の総使用量', avgUsage: '平均使用回数', avgPerUser: '平均 {n} 回/人',
                activeUsers: 'アクティブユーザー数', activeRate: '{n}% アクティブ率',
                exceededUsers: '超過ユーザー数', exceededRate: '{n}% 超過率',
            },
            date: { today: '今日', yesterday: '昨日', last3days: '直近3日', last7days: '直近7日', placeholder: '日付を選択' },
            toolbar: {
                searchPlaceholder: 'メールアドレスを検索', sortField: '並び替え項目', sortOrder: '並び順',
                sortByCount: '使用回数', sortByUserId: 'ユーザーID', sortDesc: '降順', sortAsc: '昇順', refresh: '更新',
            },
            table: {
                title: 'ユーザー使用量一覧', export: 'エクスポート', user: 'ユーザー', count: '使用回数',
                limit: '制限', usageRate: '使用率', remaining: '残り', status: 'ステータス', action: '操作',
                copyEmail: 'メールをコピー', copyId: 'IDをコピー', total: '合計 {n} 件',
                empty: 'ユーザーデータなし', emptyHint: 'ユーザーが会話を開始するまでお待ちください',
            },
            status: { exceeded: '超過', warning: '上限近い', normal: '正常' },
            customLimit: {
                tag: 'カスタム',
                setLimit: '制限設定',
                reset: 'リセット',
                dialogTitle: 'ユーザー日次制限の設定',
                user: 'ユーザー',
                dailyLimit: '日次制限',
                remark: '備考',
                remarkPlaceholder: '備考（任意）',
                cancel: 'キャンセル',
                confirm: '確認',
                setSuccess: 'ユーザー制限を設定しました',
                setFailed: '設定に失敗しました',
                removeSuccess: 'グローバルデフォルトに戻しました',
                removeFailed: '操作に失敗しました',
            },
            export: {
                account: 'アカウント', userId: 'ユーザーID', company: '会社名', count: '使用回数',
                limit: '制限', remaining: '残り', status: 'ステータス',
                success: 'エクスポート成功', filename: 'ユーザー使用統計_{date}.csv',
            },
            copied: 'コピーしました',
        },
        report: {
            refresh: '更新',
            timeWindowDefault: 'デフォルト 5分',
            timeWindow: {
                '5min': '5分', '30min': '30分', '60min': '60分',
                today: '今日', last7days: '直近7日', last30days: '直近30日',
                last3months: '直近3ヶ月', last6months: '直近半年', last1year: '直近1年',
                minutes: '{n}分',
            },
            userStatsTitle: 'ユーザー統計',
            taskStatsTitle: 'タスク統計',
            filters: {
                users: 'ユーザーでフィルター',
                companies: '会社でフィルター',
                agents: 'Agentタイプでフィルター',
                searchUser: 'メールアドレスを検索',
                searchCompany: '会社名を検索',
                agentTypes: {
                    disclosure: '開示書',
                    patentDraft: '特許出願',
                    prosecution: '審査意見書',
                },
            },
            userMetrics: {
                dau: 'デイリーアクティブユーザー（DAU）',
                mau: 'マンスリーアクティブユーザー（MAU）',
                uv: 'ユニークビジター（UV）',
                pv: 'ページビュー（PV）',
                avgDuration: '平均セッション時間',
                avgTokensPerMessage: '平均Token数/メッセージ',
            },
            userCharts: {
                tokenTask: 'Token消費 & タスク数トレンド',
                dauMau: 'DAU/MAU トレンド',
                uvPv: 'UV & PV トレンド',
                avgDuration: '平均セッション時間トレンド',
                avgConversations: 'ユーザーあたり平均会話数トレンド',
                avgTokensPerMessage: '平均Token数/メッセージトレンド',
                tokenLabel: 'Token消費',
                taskLabel: 'タスク数',
                dauLabel: 'DAU',
                mauLabel: 'MAU',
                uvLabel: 'ユニークビジター（UV）',
                pvLabel: 'ページビュー（PV）',
                avgDurationLabel: '平均セッション時間',
                avgConversationsLabel: 'ユーザーあたり平均会話数',
                avgTokensPerMessageLabel: '平均Token数/メッセージ',
            },
            metrics: {
                workers: 'オンライン Worker', activeTasks: 'アクティブタスク',
                successRate: '成功率', totalTasks: '総タスク({window})', avgDuration: '平均所要時間',
            },
            chart: { title: 'タスクトレンド', empty: 'トレンドデータなし', total: '総量', success: '成功', failure: '失敗' },
            byType: {
                title: 'タスクタイプ分布', type: 'タイプ', total: '総数',
                success: '成功', failure: '失敗', successRate: '成功率', avgDuration: '平均所要時間',
            },
            activeTasks: {
                title: '現在のアクティブタスク', fallback: 'フォールバックモード', empty: 'アクティブタスクなし',
                worker: 'Worker', taskType: 'タスクタイプ', runtime: '実行時間', taskId: 'タスクID',
            },
        },
        tokenUsage: {
            title: 'ユーザー Token 使用量一覧',
            summary: { users: 'ユーザー数', totalTokens: '総 Token', totalMessages: '総メッセージ数', totalTasks: '総タスク数', avgTokensPerTask: '平均 Token / タスク' },
            filter: {
                timeWindowPlaceholder: '時間窓を選択', statusPlaceholder: 'タスクステータス',
                statusAll: '全ステータス', statusSuccess: '成功', statusFailure: '失敗',
                statusStarted: '実行中', statusPending: '待機中',
                searchPlaceholder: 'メールアドレスを検索',
                sortByTokens: 'Total Token', sortByMessages: 'メッセージ数', sortByTasks: 'タスク数',
                sortDesc: '降順', sortAsc: '昇順', refresh: '更新',
                expandAll: '全て展開', collapseAll: '全て折りたたむ',
            },
            timeWindow: {
                '5min': '5分', '10min': '10分', '30min': '30分', '1h': '1時間',
                today: '今日', last7days: '直近7日', last30days: '直近30日',
            },
            table: {
                user: 'ユーザー', totalTokens: 'Token 使用量', messages: 'メッセージ数', tasks: 'タスク数',
                conversations: 'セッション数', conversation: 'セッション', convTokens: 'セッション Token', status: 'ステータス', ip: 'IP',
                createdAt: '作成日時', empty: 'Token使用データなし',
            },
            pagination: { total: '合計 {n} ユーザー' },
            copied: 'コピーしました',
        },
        model: {
            agentSection: 'Agent モデル設定', agentCount: '{n} 個の Agent',
            taskSection: 'タスクレベル上書き', taskCount: '{n} 件',
            modelLabel: 'モデル', modelPlaceholder: 'モデルを検索または選択',
            tempLabel: '温度 ({val})', tempPlaceholder: '温度', maxTokensPlaceholder: '制限なし',
            maxOutput: '最大出力 {n}', maxTemp: '最大温度 {n}',
            multimodal: 'マルチモーダル', thinking: '推論',
            multimodalSupport: 'マルチモーダル対応', thinkingSupport: '推論対応',
            taskHeader: { task: 'タスク', model: 'モデル', temp: '温度' },
            categories: { drafting: '特許作成', prosecution: 'OA対応', rag: '文書処理', image: '画像分析', general: '汎用', style: 'スタイル抽出' },
            save: '設定を保存', undoEdit: '編集を元に戻す', resetDefault: 'デフォルトに戻す', unsaved: '未保存の変更があります',
            loadFail: 'モデル設定の読み込み失敗', saveSuccess: 'モデル設定を保存しました', saveFail: 'モデル設定の保存失敗',
            undoDone: '未保存の編集を元に戻しました',
            resetConfirmMsg: 'すべてのカスタム設定を削除し、システムデフォルトに戻します。この操作は元に戻せません。',
            resetConfirmTitle: 'リセットの確認', resetConfirmBtn: 'デフォルトに戻す', resetCancel: 'キャンセル',
            resetSuccess: 'システムデフォルトに戻しました', resetFail: 'デフォルトへのリセット失敗',
        },
        tool: {
            baseTools: '基本ツール（設定不可）', specificTools: '専務ツール（設定可能）',
            itemCount: '{n} 件', required: '必須', noSpecificTools: 'この Agent には専務ツールがありません',
            save: '設定を保存', reset: 'リセット', unsaved: '未保存の変更があります',
            loadFail: 'ツール設定の読み込み失敗', saveSuccess: 'ツール設定を保存しました',
            saveFail: 'ツール設定の保存失敗', resetDone: '前回保存した設定にリセットしました',
        },
        proLimit: {
            title: 'Pro ユーザー文書数上限',
            patentDraftLimit: '特許作成上限',
            disclosureLimit: '開示書上限',
            oarLimit: '審査意見上限',
            unit: '件',
            saveSuccess: 'Pro 文書上限を保存しました',
            saveFail: '保存に失敗しました',
            loadFail: '読み込みに失敗しました',
        },
        freeLimit: {
            title: 'Free ユーザー文書数上限',
            totalDocumentLimit: '文書総量上限',
            patentDraftLimit: '特許作成上限',
            disclosureLimit: '開示書上限',
            oarLimit: '審査意見上限',
            unit: '件',
            saveSuccess: 'Free 文書上限を保存しました',
            saveFail: '保存に失敗しました',
            loadFail: '読み込みに失敗しました',
        },
        prompt: {
            config: {
                title: 'Langfuse 設定',
                publicKeyLabel: 'Public Key', secretKeyLabel: 'Secret Key', hostLabel: 'Host URL（任意）',
                testConnection: '接続テスト', loadPrompts: '全 Prompts を読み込む',
                checkSync: '同期状態を確認', batchPush: '一括プッシュ',
                promptNamePlaceholder: 'Prompt 名を入力', fetch: '取得',
                missingKeys: 'Public Key と Secret Key を入力してください',
                connectSuccess: '接続成功！', connectFail: '接続失敗: {msg}',
                loadSuccess: '{n} 個の Prompts を読み込みました', loadFail: 'Prompts の読み込み失敗: {msg}',
                fetchFail: 'Prompt の取得失敗: {msg}', promptNameRequired: 'Prompt 名を入力してください',
                connectFirst: '先に接続テストを行ってください', loadFirst: '先に Prompts を読み込んでください',
            },
            list: {
                title: 'Prompt 管理', count: '合計 {n} 個', searchPlaceholder: 'prompts を検索...',
                loading: 'Prompts を読み込み中...', empty: 'Prompts データなし', reload: '再読み込み',
                colName: '名前', colType: 'タイプ', colLabels: 'ラベル',
                colSyncStatus: '同期状態', colActions: '操作',
                view: '表示', push: 'プッシュ', synced: '同期済み', unchecked: '未確認',
            },
            sync: {
                same: '同期済み', different: '更新必要', frontendOnly: 'プッシュ待ち', backendOnly: 'バックエンドのみ',
                checkDone: '同期確認完了！合計 {total} 個 - 同期済み: {same}, 更新必要: {diff}, プッシュ待ち: {pending}, バックエンドのみ: {backend}',
                checkFail: '同期確認失敗: {msg}',
            },
            push: {
                dialogTitle: 'Prompts をバックエンドにプッシュ', selected: '{n} 個の Prompts を選択中',
                overwrite: '既存の Prompts を上書き',
                pushing: '分割プッシュ中、1バッチ最大5個...',
                cancel: 'キャンセル', pushBtn: 'プッシュ ({n})', nothingToPush: 'プッシュが必要な Prompts はありません',
                batchInfo: 'バッチ {cur}/{total} をプッシュ中 ({n} 個)...',
                batchDone: 'バッチ {n} 完了！成功: {success}, 失敗: {fail}',
                allDone: '全バッチ完了！合計 - 成功: {success}, 失敗: {fail}, スキップ: {skip}',
                pushFail: 'プッシュ失敗: {msg}',
                singleSuccess: '{name} のプッシュ成功！', singleSkipped: '{name} のプッシュをスキップ',
                singleFail: '{name} のプッシュ失敗: {msg}',
            },
            detail: {
                name: '名前', type: 'タイプ', version: 'バージョン', labels: 'ラベル',
                content: 'Prompt 内容：', fetchFail: 'Prompt 詳細の取得失敗: {msg}',
            },
        },
        assetStats: {
            totalTemplates: '総テンプレート数',
            totalInstructions: '総指示数',
            totalStyles: '総スタイル数',
            startDate: '開始日',
            endDate: '終了日',
            searchUser: 'メールアドレスを検索',
            user: 'ユーザー',
            templates: 'テンプレート',
            instructions: '指示',
            styles: 'スタイル',
            all: '全て',
            today: '今日',
            yesterday: '昨日',
            last7days: '過去7日間',
            last30days: '過去30日間',
            refresh: '更新',
            tableTitle: 'アセット統計',
            empty: 'データなし',
            copied: 'コピー済み',
            total: '合計 {n} 件',
        },
        documentStats: {
            docGroup: '文書統計',
            assetGroup: 'アセット統計',
            totalDocuments: '総文書数',
            totalExports: '総エクスポート数',
            startDate: '開始日',
            endDate: '終了日',
            searchUser: 'メールアドレスを検索',
            searchUserBatch: 'メールまたはユーザーID（カンマ区切り）',
            user: 'ユーザー',
            userId: 'ユーザーID',
            company: '会社',
            email: 'メール',
            disclosure: '開示書',
            patentDraft: '特許出願',
            prosecution: '審査意見応答',
            totalCount: '総文書数',
            exportCount: 'エクスポート数',
            templateCount: 'テンプレート',
            instructionCount: '指示',
            styleCount: 'スタイル',
            folderCount: 'フォルダ数',
            totalTemplates: '総テンプレート数',
            totalInstructions: '総指示数',
            totalStyles: '総スタイル数',
            totalFolders: '総フォルダ数',
            all: '全て',
            today: '今日',
            yesterday: '昨日',
            last7days: '直近7日',
            last30days: '直近30日',
            custom: 'カスタム',
            refresh: '更新',
            tableTitle: 'アセット統計',
            empty: 'データなし',
            copied: 'コピーしました',
            total: '{n} 件',
            userTypeAll: '全ユーザー',
            userTypeInternal: '社内ユーザー',
            userTypeExternal: '社外ユーザー',
            filterTimeRange: '期間',
            filterUser: 'ユーザー絞り込み',
            search: '検索',
            reset: 'リセット',
            bulkSearch: '一括検索',
            bulkSearchHint: '1行に1メール、またはカンマ・スペースで区切り',
            uploadFile: 'ファイルをアップロード',
            uploadFileHint: '.xlsx / .xls / .csv 対応、1列目がメールアドレス',
            dropZoneText: 'Excel / CSV ファイルをここにドラッグ、またはクリックしてアップロード',
            emailInputPlaceholder: 'メールを入力し、Enterで追加',
            recognizedCount: '{n} 件のメールを認識',
            clearAll: 'すべてクリア',
            cancel: 'キャンセル',
            emailCount: '{n} 件のメール',
            importedCount: '{n} 件のメールをインポート済み',
            clearImport: 'クリア',
            export: 'エクスポート',
            exportAll: 'すべてエクスポート',
            exportSelected: '選択をエクスポート',
            selectedCount: '{n} 件選択中',
            exportSuccess: 'エクスポート成功',
            parseError: 'ファイルの解析に失敗しました',
            noEmailFound: '有効なメールアドレスが見つかりません',
        },
        feedback: {
            title: 'ユーザーフィードバック管理',
            totalCount: '全 {n} 件',
            searchEmail: 'メールアドレスを検索',
            statusPlaceholder: 'ステータス',
            categoryPlaceholder: 'カテゴリ',
            priorityPlaceholder: '優先度',
            refresh: '更新',
            emptyText: 'フィードバックデータなし',
            colUser: 'ユーザー',
            colTitle: 'タイトル',
            colCategory: 'カテゴリ',
            colStatus: 'ステータス',
            colPriority: '優先度',
            colTime: '送信日時',
            copyEmail: 'メールをコピー',
            copyId: 'IDをコピー',
            copyProjectId: 'Project IDをコピー',
            copied: 'コピーしました',
            paginationTotal: '全 {n} 件',
            status: {
                pending: '未処理',
                processing: '処理中',
                resolved: '解決済み',
                closed: 'クローズ',
            },
            category: {
                bug: 'バグ',
                suggestion: '提案',
                feature_request: '機能リクエスト',
                other: 'その他',
            },
            priority: {
                high: '高',
                medium: '中',
                low: '低',
            },
            drawer: {
                statusLabel: 'ステータス',
                priorityLabel: '優先度',
                statusPending: '未処理',
                statusProcessing: '処理中',
                statusResolved: '解決済み',
                statusClosed: 'クローズ',
                priorityHigh: '高',
                priorityMedium: '中',
                priorityLow: '低',
                adopt: '採用',
                noMessages: 'メッセージ記録なし',
                replyPlaceholder: '返信内容を入力、Enter で改行、Ctrl+Enter で送信...',
                replyHint: 'Ctrl+Enter で送信',
                sendReply: '返信を送信',
                statusLabelPending: '未処理',
                statusLabelProcessing: '処理中',
                statusLabelResolved: '解決済み',
                statusLabelClosed: 'クローズ',
                categoryBug: 'バグ',
                categorySuggestion: '提案',
                categoryFeatureRequest: '機能リクエスト',
                categoryOther: 'その他',
                priorityHighLabel: '高優先度',
                priorityMediumLabel: '中優先度',
                priorityLowLabel: '低優先度',
            },
        },
        modelConfig: {
            groupLabel: '設定グループ',
            activeTag: 'アクティブ',
            create: '新規作成',
            rename: '名前変更',
            delete: '削除',
            createDialogTitle: '設定グループを作成',
            nameLabel: '名前',
            namePlaceholder: '例: GPT優先、エコノミーモード',
            copyFromLabel: 'コピー元',
            copyFromPlaceholder: 'コピーしない（空の設定）',
            cancel: 'キャンセル',
            createBtn: '作成',
            renameDialogTitle: '設定グループの名前変更',
            renamePlaceholder: '新しい名前',
            save: '保存',
            switchSuccess: '設定グループを切り替えました',
            switchFail: '設定グループの切り替えに失敗しました',
            nameRequired: 'グループ名を入力してください',
            createSuccess: '設定グループを作成しました',
            createFail: '作成に失敗しました',
            updateSuccess: '設定グループを更新しました',
            updateFail: '更新に失敗しました',
            deleteConfirmMsg: '設定グループ「{name}」を削除しますか？この操作は元に戻せません。',
            deleteConfirmTitle: '設定グループの削除',
            deleteConfirmBtn: '削除',
            deleteSuccess: '設定グループを削除しました',
            deleteFail: '削除に失敗しました',
        },
        langfuse: {
            connectionFallback: '接続失敗',
            connectionFailMsg: '接続失敗: {msg}',
            connectFirst: '先に接続テストを行ってください',
            promptNameRequired: 'Prompt名を入力してください',
        },
        payment: {
            totalCount: '総件数',
            totalAmount: '総額 (USD)',
            records: '決済記録',
            total: '合計 {n} 件',
            searchPlaceholder: 'メール/プランを検索',
            startDate: '開始日',
            endDate: '終了日',
            refresh: '更新',
            emptyText: '決済記録なし',
            user: 'ユーザー',
            plan: 'プラン',
            amount: '金額',
            cycle: '周期',
            time: '日時',
            monthly: '月払い',
            yearly: '年払い',
            loadFailed: '決済記録の読み込み失敗',
            statsFailed: '統計の読み込み失敗',
        },
        skill: {
            patentOffice: '特許庁',
            mode: 'モード',
            modeAgent: 'フルモード',
            modeCopilot: 'コパイロットモード',
            disclosure: '開示書',
            patentDraft: '特許出願',
            prosecution: '審査意見応答',
            empty: 'データなし',
            loadFailed: '読み込み失敗',
            save: '保存',
            reset: 'リセット',
            saveSuccess: '保存しました',
            saveFailed: '保存に失敗しました',
            editor: { edit: '編集', split: '分割', preview: 'プレビュー' },
        },
        role: {
            searchPlaceholder: 'メールで検索',
            search: '検索',
            assign: 'ロール割り当て',
            email: 'メール',
            role: 'ロール',
            assignedBy: '割り当て者',
            remark: '備考',
            createdAt: '作成日時',
            action: '操作',
            remove: '削除',
            assignTitle: 'ロール割り当て',
            cancel: 'キャンセル',
            confirm: '確認',
        },
    },
};
